/**
 * Copyright 2020, IntraLinks, Inc. All rights reserved.
 */

var DEBOUNCE_DEFAULT_VALUE = 400;
var DEBOUNCE_MIN_CHARS_FOR_SEARCH = 3;
var DEFAULT_OPTIONS_LIMIT = 5;
var DEFAULT_NO_OPTION_TEXT = 'No options';

export { DEBOUNCE_DEFAULT_VALUE, DEBOUNCE_MIN_CHARS_FOR_SEARCH, DEFAULT_NO_OPTION_TEXT, DEFAULT_OPTIONS_LIMIT };
